module.exports = __webpack_public_path__ + "static/media/SteamIronsbanner.385c20cd.png";